import { styled } from '@mui/material/styles';
import { Box, FormControl } from '@mui/material';

import { useTourContext } from 'src/presentations/guided-tours';
import { useShipmentSelector } from '../ShipmentSelector.tsx';

// Import refactored components and hooks
import { useShipmentOptions } from './shipmentOptions/useShipmentOptions.tsx';
import { useShipmentDropdown } from './shipmentOptions/useShipmentDropdown';
import { useShipmentActions } from './shipmentOptions/useShipmentActions';
import { ShipmentActionButtons } from './shipmentOptions/ShipmentActionButtons.tsx';
import { ShipmentDropdownPopover } from './shipmentOptions/ShipmentDropdownPopover.tsx';
import { ShipmentSelectorButton } from './shipmentOptions/ShipmentSelectorButton.tsx';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MuiFormControl-root': {
    minWidth: '290px',
    [theme.breakpoints.down(1520)]: {
      minWidth: '240px',
    },
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
  '& MuiList-root': {
    boxShadow: '0px 12px 12px 0px rgba(34, 65, 102, 0.09)',
  },
}));

export const ActionDetailShipmentOptions = () => {
  // Context and hooks
  const { shipmentInvoiceId } = useShipmentSelector();
  const tour = useTourContext().appTour.registerTour('actionDetails');

  // Generate options
  const { options, createShipmentOption } = useShipmentOptions();

  // Dropdown UI state and filtering
  const dropdown = useShipmentDropdown({ options, createShipmentOption });

  // Actions and side effects
  const actions = useShipmentActions({ options });

  if (!shipmentInvoiceId) {
    return null;
  }

  return (
    <>
      <StyledBox>
        <FormControl size='small'>
          <div id={tour.registerStep('shipmentDropdown')}>
            <ShipmentSelectorButton dropdown={dropdown} actions={actions} />
          </div>

          <ShipmentDropdownPopover dropdown={dropdown} actions={actions} />
        </FormControl>
      </StyledBox>

      <ShipmentActionButtons actions={actions} />
    </>
  );
};
